import { FunctionComponent } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import PublicHomePage from './PublicHomePage';
import PublicAboutUsPage from './PublicAboutUsPage';
import PublicMapPage from './PublicMapPage';
import Login from '../../components/auth/Login';
import SignUp from '../../components/auth/SignUp';
import NotFoundPage from '../NotFoundPage';
import PublicWhatWeDoPage from './PublicWhatWeDoPage';
import PublicNavBar from '../../components/PublicNavbar';
import Footer from '../../components/Footer';
import HeatMapPage from './HeatMapPage';

const PublicPage: FunctionComponent = () => {
  const location = useLocation();
  /*
  the base path is /public
  E.g.: if the path '/login' we are is given it will redirect to '/public/login' we are
  */
  return (
    <>
      <PublicNavBar />
      <Routes>
        <Route path='/' element={<PublicHomePage />} />
        <Route path='/login' element={<Login />} />
        <Route path='/sign-up' element={<SignUp />} />
        <Route path='/quienes-somos' element={<PublicAboutUsPage />} />
        <Route path='/que-hacemos' element={<PublicWhatWeDoPage />} />
        <Route path='/ver-mapa' element={<PublicMapPage />} />
        <Route path='/mapa-de-calor' element={<HeatMapPage />} />
        <Route path='*' element={<NotFoundPage />} />
      </Routes>
      {location?.pathname === '/public/ver-mapa' ? null : <Footer />}
    </>
  );
};

export default PublicPage;
